import {
  Card,
  CardBody,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  CardHeader,
  CardTitle,
} from "reactstrap";
import { useState, React, useEffect, useRef, useContext } from "react";
import { NavLink, useHistory } from "react-router-dom";
import "moment-timezone";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingOverlay from "react-loading-overlay";
import { MainContext } from "context/MainContext.js";
LoadingOverlay.propTypes = undefined;

import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";

const VersionUpload = () => {
  const history = useHistory();
  const privileges = useContext(MainContext);

  useEffect(() => {
    if (!Utilities.hasAccess(privileges["versions.upload.display"])) {
      history.push({
        pathname: "/",
      });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({
        pathname: "/auth/terms",
      });
    }

    fetchData();
  }, []);

  const fetchData = () => {
    fetch("/api/v1/version/upload", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
    })
      .then((response) => response.json())
      .then((actualData) => {})
      .catch((err) => {
        console.log(err.message);
      });
  };

  const [showLoading, setShowLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState([]);

  const [file, setFile] = useState();
  const [uploadBtnEnabled, setUploadBtnEnabled] = useState(false);

  const handleUpload = () => {
    setShowLoading(true);

    const uploadFile = inputFileRef.current.files[0];

    const formData = new FormData();
    formData.append("file", uploadFile);

    fetch("/api/v1/version/upload", {
      method: "PUT",
      headers: {
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: formData,
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        setFile();
        inputFileRef.current.value = null;
        setUploadBtnEnabled(false);

        if (actualData.status != 200) {
          setErrorMsg(actualData.error_code);
          toast.error("A problem occured while uploading the version", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        } else {
          setErrorMsg([]);
          toast.success("Version uploaded successfully", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        }
      })
      .catch((error) => {
        console.log(error.message);
        toast.error("A problem occured while uploading the version", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          theme: "colored",
        });
        setShowLoading(false);
        setFile([]);
        inputFileRef.current.value = null;
        setUploadBtnEnabled(false);
        console.log(error.message);
      });
  };

  const handleFileChange = (event) => {
    const selectedFile = Array.from(event.target.files);

    if (selectedFile == undefined || selectedFile.length == 0) {
      setUploadBtnEnabled(false);
    } else {
      setUploadBtnEnabled(true);
    }

    setFile(selectedFile);
  };

  const inputFileRef = useRef(null);

  return (
    <>
      <ToastContainer />
      <div className="content">
        <LoadingOverlay
          active={showLoading}
          spinner
          text="Loading"
          className={showLoading ? "loading" : ""}
        />
        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <Breadcrumb>
                  <BreadcrumbItem>
                    <NavLink
                      to={{
                        pathname: "/admin/dashboard",
                      }}
                    >
                      <FontAwesomeIcon icon={faHome} />
                    </NavLink>
                  </BreadcrumbItem>
                  <BreadcrumbItem>Virtuoso Version Upload</BreadcrumbItem>
                </Breadcrumb>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Virtuoso Version Upload</CardTitle>
              </CardHeader>
              <CardBody>
                {errorMsg.length > 0 ? (
                  <div
                    style={{
                      backgroundColor: "#FFC0A4",
                      border: "1px solid #ef8157",
                      color: "#66615b",
                      paddingTop: "15px",
                      marginBottom: "15px",
                    }}
                  >
                    <ul>
                      {errorMsg.map((d, index) => (
                        <li key={index}>{d}</li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  ""
                )}
                <Row>
                  <Col>
                    This section allows you to upload new Virtuoso version.
                  </Col>
                </Row>
                <Row style={{ marginTop: "25px", marginBottom: "25px" }}>
                  <Col>
                    <div>
                      <input
                        type="file"
                        onChange={handleFileChange}
                        ref={inputFileRef}
                        accept=".tar"
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div>
                      <button
                        onClick={handleUpload}
                        disabled={!uploadBtnEnabled}
                      >
                        Upload
                      </button>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default VersionUpload;
